export default __webpack_public_path__ + "static/9-a813552bde96417e7a02a22b19869c79.webp";